import {
  BarVisualizer,
  RoomAudioRenderer,
  RoomContext,
  StartAudio,
  useVoiceAssistant,
  useConnectionState,
} from "@livekit/components-react";

import { Button } from "V2.0/common/button";
import { MicrophoneIcon } from "@heroicons/react/24/outline";
import { message } from "antd";
import clsx from "clsx";
import { MdOutlineCallEnd } from "react-icons/md";
import { AiOutlineLoading3Quarters } from "react-icons/ai";

function WebCall(props) {
  const { onConnect, onDisconnect, onClose } = props;

  const connectionState = useConnectionState();
  const { state, audioTrack } = useVoiceAssistant();

  const handleConnect = async () => {
    const micPermission = await navigator.permissions.query({
      name: "microphone",
    });

    if (micPermission.state === "denied") {
      onClose();
      message.error("Please enable microphone");

      return;
    }

    if (micPermission.state === "prompt") {
      navigator.mediaDevices
        .getUserMedia({ audio: true })
        .then(() => {
          onConnect(onClose);
        })
        .catch((error) => {
          onClose();
          message.error("Please enable microphone");
        });

      return;
    }

    onConnect(onClose);
  };

  if (connectionState === "connecting") {
    return (
      <Button disabled>
        <AiOutlineLoading3Quarters className="animate-spin" />
        Connecting
      </Button>
    );
  }

  if (connectionState === "connected") {
    return (
      <div className="flex flex-col gap-y-2 items-center">
        <BarVisualizer
          barCount={10}
          state={state}
          options={{ minHeight: 10 }}
          trackRef={audioTrack}
          className="flex aspect-video w-40 items-center justify-center gap-2"
        >
          <span
            className={clsx([
              "bg-blue-300 min-h-10 w-2 rounded-full",
              "origin-center transition-colors duration-250 ease-linear",
              "data-[lk-highlighted=true]:bg-foreground data-[lk-muted=true]:bg-muted",
            ])}
          />
        </BarVisualizer>
        <div>
          <Button
            color="red"
            onClick={() => {
              onDisconnect();
            }}
          >
            <MdOutlineCallEnd className="size-4" /> End
          </Button>
        </div>
      </div>
    );
  }

  if (connectionState === "disconnected") {
    return (
      <Button onClick={handleConnect}>
        <MicrophoneIcon /> Speak
      </Button>
    );
  }
}

export function LivekitWebCall(props) {
  const { room, onConnect, onClose } = props;

  return (
    <>
      <RoomContext.Provider value={room}>
        <RoomAudioRenderer />
        <StartAudio label="Start Audio" />
        <WebCall
          onConnect={onConnect}
          onDisconnect={() => {
            room.disconnect();
          }}
          onClose={onClose}
        />
      </RoomContext.Provider>
    </>
  );
}
